import interval from "./interval";
import {durationSecond} from "./duration";

var second = interval(function(date) {
  date.setTime(Math.floor(date / durationSecond) * durationSecond);
}, function(date, step) {
  date.setTime(+date + step * durationSecond);
}, function(start, end) {
  return (end - start) / durationSecond;
}, function(date) {
  return date.getUTCSeconds();
});

export default second;
export var seconds = second.range;



//////////////////
// WEBPACK FOOTER
// ./~/d3-time/src/second.js
// module id = 1453
// module chunks = 0